import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Toast } from './toast.service';

@Component({
  selector: 'tog-toast',
  templateUrl: 'toast.template.html',
  styleUrls: ['toast.scss'],
})
export class ToastComponent implements OnInit {
  @Input() toast: any;
  openToast: boolean = false;
  toastHtml: HTMLElement;

  constructor(private _toast: Toast) { }

  ngOnInit() {
    this.toastHtml = document.getElementById('main');
    let self = this;
    setTimeout(() => {
      self.openToast = true;
      this.toastHtml.style.right = '30px';
      this.toastHtml.style.opacity = '1';
    }, 50);
    setTimeout(() => {
      self.dismissToast();
    }, 3500);
  }

  dismissToast() {
    this.toastHtml.style.right = '-350px';
    this.toastHtml.style.opacity = '0';
    this.openToast = false;
    this._toast.removeToast(this.toast);
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/components/toast/toast.component.ts